import { render, staticRenderFns } from "./OaoBrowserMessage.vue?vue&type=template&id=baa48124&scoped=true&functional=true"
import script from "./OaoBrowserMessage.vue?vue&type=script&lang=js"
export * from "./OaoBrowserMessage.vue?vue&type=script&lang=js"
import style0 from "./OaoBrowserMessage.vue?vue&type=style&index=0&id=baa48124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0d1d51ab4c56f75a7402f3cb98fb63e0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "baa48124",
  null
  
)

export default component.exports